import { GeoTargetingDTO } from './GeoTargetingDTO';
import { FormBuilder, Validators } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { FlightScheduleDTO } from './FlightScheduleDTO';
import { DemoSettingsDTO } from './DemoSettingDTO';
import { FrequencyCapDTO } from './FrequencyCapDTO';
import { GoalDTO } from './GoalDTO';
import { EnvironmentConst } from '../components/planner-edit/constants/Environment.const';
import { frequencyCapValidator, greaterThanZero } from '../validators/customValidators';
import { Operator } from '../enums/Operator.enum';
import { SegmentTargetType } from '../constants/SegmentTargetType';
import { ConceptSetDTO } from './ConceptSetDTO';
import { AdditionalCostDTO } from './AdditionalCostDTO';
import { BudgetDistributionDTO } from './BudgetDistributionDTO';
// import { VideoDuration } from '../components/planner-edit/constants/VideoDuration.const';

export class DigitalTacticDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'environments',
            type: 'Array<number>',
            defaultValue: Object.values(EnvironmentConst).map(env => env.id),
            validators: [Validators.required]
        },
        {
            name: 'inventorySources',
            type: 'Array<number>',
            defaultValue: []
        },
        {
            name: 'deals',
            type: 'Array<IdNameVO>',
            defaultValue: []
        },
        {
            name: 'preferredDeals',
            type: 'Array<IdNameVO>',
            defaultValue: []
        },
        {
            name: 'pgDeals',
            type: 'Array<IdNameVO>',
            defaultValue: []
        },
        {
            name: 'deviceTypes',
            type: 'Array<string>',
            defaultValue: []
        },

        {
            name: 'includeSegments',
            type: 'Array<IdNameVO>',
            defaultValue: []
        },
        {
            name: 'includeOperator',
            type: Operator,
            defaultValue: Operator.or
        },
        {
            name: 'excludeSegments',
            type: 'Array<IdNameVO>',
            defaultValue: []
        },
        {
            name: 'excludeOperator',
            type: Operator,
            defaultValue: Operator.or
        },
        {
            name: 'segmentSet',
            type: 'IdNameVO',
            defaultValue: {}
        },
        {
            name: 'segmentTargetingType',
            type: SegmentTargetType,
        },
        //Not supported for V1 as per [CSYS-5054]
        // {
        //     name: 'videoDuration',
        //     type: VideoDuration,
        //     defaultValue: VideoDuration.Sec30.id
        // },
        // {
        //     name: 'vpaid',
        //     type: 'boolean',
        //     defaultValue: false
        // },
        { name: 'useLinearSchedule', type: 'boolean' },
        {
            name: 'flightSchedule',
            type: 'formArray',
            arrayClass: FlightScheduleDTO,
            createInitialItem: false
        },
        {
            name: 'goals',
            type: 'formArray',
            arrayClass: GoalDTO,
            createInitialItem: true
        },
        {
            name: 'demoSetting',
            type: 'formGroup',
            arrayClass: DemoSettingsDTO,
            createInitialItem: true
        },
        {
            name: 'frequencyCap',
            type: 'formGroup',
            arrayClass: FrequencyCapDTO,
            createInitialItem: true,
            groupValidator: frequencyCapValidator()
        },
        {
            name: 'adsTxtStatuses',
            type: 'Array<number>',
            defaultValue: [0, 1, 2]
        },
        {
            name: 'playerSizes',
            type: 'Array<number>',
            defaultValue: [0, 1, 2, 3, 5]
        },
        {
            name: 'adVisibility',
            type: 'Array<number>',
            defaultValue: [0, 1, 2]
        },
        { name: 'enableCrossDeviceTargeting', type: 'boolean' },
        {
            name: 'crossDeviceTargeting',
            type: 'Set<CrossDevice>',
            defaultValue: []
        },
        { name: 'derivedId', type: 'boolean' },
        {
            name: 'regionMap',
            type: 'formGroup',
            arrayClass: GeoTargetingDTO,
            createInitialItem: true
        },
        { name: 'siteLists', type: 'Array<InventoryListVO>', defaultValue: [] },
        { name: 'appLists', type: 'Array<InventoryListVO>', defaultValue: [] },
        {
            name: 'daypartMatrix',
            type: 'Array<Array<boolean>>',
            defaultValue: Array.from({ length: 24 }, () => Array(7).fill(true))
        },
        { name: 'videoViewabilityPartner', type: 'IdNameVO', defaultValue: {} },
        { name: 'mobileViewabilityPartner', type: 'IdNameVO', defaultValue: {} },
        { name: 'videoViewabilityCPM', type: 'number' },
        { name: 'iasVideoViewabilityCPM', type: 'number' },
        { name: 'mobileViewabilityCPM', type: 'number' },
        { name: 'maxBid', type: 'number', validators: [greaterThanZero()] },
        /* hide max average bid for now
        { name: 'averageBid', type: 'number', validators: [greaterThanZero()] },
        */
        {
            name: 'brandSafety',
            type: 'formGroup',
            arrayClass: ConceptSetDTO,
            createInitialItem: true
        },
        {
            name: 'pageQuality',
            type: 'formGroup',
            arrayClass: ConceptSetDTO,
            createInitialItem: true
        },
        {
            name: 'contextual',
            type: 'formGroup',
            arrayClass: ConceptSetDTO,
            createInitialItem: true
        },
        {
            name: 'thirdPartyCost',
            type: 'formArray',
            arrayClass: AdditionalCostDTO,
            createInitialItem: false
        },
        {
            name: 'budgetDistribution',
            type: 'formGroup',
            arrayClass: BudgetDistributionDTO,
            createInitialItem: true
        }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
